import { getP } from 'redux-polyglot'
import {
  REGISTER_INPUT_EMAIL,
  REGISTER_INPUT_PASSWORD,
  REGISTER_INPUT_USERNAME
} from '../constants/register'
import api from '../libs/api'

/**
 * Actions for performing the register
 */
export const REGISTER_REQUEST = 'AUTH/REGISTER/REQUEST'
export const REGISTER_SUCCESS = 'AUTH/REGISTER/SUCCESS'
export const REGISTER_FAILURE = 'AUTH/REGISTER/FAILURE'

const registerRequest = () => ({
  type: REGISTER_REQUEST,
})

const registerSuccess = () => ({
  type: REGISTER_SUCCESS
})

const registerFailure = (error, errors) => {
  const payload = error instanceof Error ? error : new Error(error)
  payload.errors = errors
  return {
    type: REGISTER_FAILURE,
    payload: payload,
    error: true
  }
}

export const register = (username, email, password) => (dispatch, getState) => {
  dispatch(registerRequest())
  return api.register(username, email, password)
    .then(res => res.json())
    .then(
      response => {
        if (response.status === 200) {
          return dispatch(registerSuccess())
        } else {
          return dispatch(registerFailure(response.reason, response.errors))
        }
      },
      () => dispatch(registerFailure(getP(getState()).t("tv_auth.error_account_registration", { _: "An error occurred while registering your new account" })))
    )
}

/**
 * Actions related to keyboard on register screen
 */
export const FOCUS_INPUT = 'REGISTER/FOCUS_INPUT'
export const UPDATE_INPUT = 'REGISTER/UPDATE_INPUT'
export const DELETE_INPUT = 'REGISTER/DELETE_INPUT'
export const ERROR_INPUT = 'REGISTER/ERROR_INPUT'
export const SET_STATUS = 'REGISTER/SET_STATUS'
export const FOCUS_KEYBOARD = 'REGISTER/FOCUS_KEYBOARD'
export const RESET = 'REGISTER/RESET'

export const focusInput = (focusedInput, focusedRow, focusedCol) => {

  let newFocusedInput
  switch(focusedInput) {
    case REGISTER_INPUT_USERNAME:
    case REGISTER_INPUT_EMAIL:
    case REGISTER_INPUT_PASSWORD:
      newFocusedInput = focusedInput
      break;
    default:
      newFocusedInput = REGISTER_INPUT_USERNAME
  }

  return {
    type: FOCUS_INPUT,
    payload: {
      focusedInput: newFocusedInput,
      focusedRow: focusedRow,
      focusedCol: focusedCol
    }
  }
}

export const updateInput = newKey => ({
  type: UPDATE_INPUT,
  payload: {
    newKey
  }
})

export const deleteInput = () => ({
  type: DELETE_INPUT
})

export const errorInput = (input, error) => ({
  type: ERROR_INPUT,
  payload: {
    input,
    error
  }
})


export const setStatus = (status) => ({
  type: SET_STATUS,
  payload: {
    status
  }
})

export const focusKeyboard = (focus) => ({
  type: FOCUS_KEYBOARD,
  payload: {
    focus
  }
})

export const reset = () => ({
  type: RESET
})
